import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials, MoreTestimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { BonusesTable } from './components/BonusesTable';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-gold-500/30 selection:text-gold-200" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <StatsBar data-id="element-3" />
        <Testimonials data-id="element-4" />
        <PainSection data-id="element-5" />
        <ProductBreakdown data-id="element-6" />
        <BonusesTable data-id="element-7" />
        <PricingSection data-id="element-8" />
        <MoreTestimonials data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <CostComparison data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}